// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2YUBx","insightsList":"newBusinessInsightsMenu_insightsList__19HBY","active":"newBusinessInsightsMenu_active__2efQU"};